import axios from "axios";
import { url } from "../config";

export default function test(){
    console.log("test function from helper.js");
} ;

export const login = async (endpoint, data) => {
    try {
        const response = await axios.post(`${url}/${endpoint}`, data);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getData = async (endpoint, token) => {
    try {
        const response = await axios.get(`${url}/${endpoint}`, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token') || token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const postData = async (endpoint, data, token) => {
    try {
        const response = await axios.post(`${url}/${endpoint}`, data, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token') || token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export const putData = async (endpoint, data, token) => {
    try {
        const response = await axios.put(`${url}/${endpoint}`, data, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token') || token}`,
                'Content-Type': 'application/json',
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const deleteData = async (endpoint, token) => {
    try {
        const response = await axios.delete(`${url}/${endpoint}`, {
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token') || token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}